import { render, staticRenderFns } from "./Personali.vue?vue&type=template&id=1f67ff3e&"
import script from "./Personali.vue?vue&type=script&lang=js&"
export * from "./Personali.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports